import { FunctionComponent, memo } from 'react';
import { FeedCardPollCommon, FeedCardProps } from '../../../shared';

export const FeedCardAdminPoll: FunctionComponent<FeedCardProps> = memo((props) => {
  return <FeedCardPollCommon {...props} />;
});
